








































import { Component, Vue, Prop } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import { Loader } from "../forms/parts";

@Component({
  components: {
    Loader
  }
})
export default class FaqCategorySpotlight extends Vue {
  @Prop() categoryIds!: number[];

  @Prop() category?: string;

  @Prop({ default: false }) single?: boolean;

  @Prop({ default: true }) async?: boolean;

  loading: boolean = false;

  params: any = { per_page: 4, page: 1, slim: 1 };

  faqs: any = [];

  categories: any = [];

  search: string = "";

  async mounted() {
    if (this.async) {
      if (this.single) {
        this.params.per_page = 99;
      } else {
        await this.getCategories();
      }

      for (const id of this.categoryIds) {
        await this.getFaq(id);
      }
    }
  }

  private async getFaq(category: number) {
    this.loading = true;

    // @ts-ignore
    return axios
      .get("/api/faq", { params: { ...this.params, faq_categories: [category] } })
      .then((response: any) => {
        this.faqs = this.faqs.concat(response.data.data);
      })
      .finally(() => (this.loading = false));
  }

  @Debounce(500)
  private async handleSearch() {
    this.faqs = [];

    if (this.categories.length === 0) {
      await this.getCategories();
    }

    if (this.search === "") {
      for (const id of this.categoryIds) {
        await this.getFaq(id);
      }
      return;
    }

    this.loading = true;

    // @ts-ignore
    return axios
      .get("/api/faq", { params: { ...this.params, search: this.search } })
      .then((response: any) => {
        this.faqs = response.data.data;
      })
      .finally(() => (this.loading = false));
  }

  private async getCategories() {
    this.loading = true;
    // @ts-ignore
    return axios
      .get("/api/categories", { params: { taxonomy: "faq_categories" } })
      .then((response: any) => {
        this.categories = Object.values(response.data.data);
      })
      .finally(() => (this.loading = false));
  }

  private sliceIntoChunks(arr: any, chunkSize: number) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res;
  }

  get computedCategories() {
    if (this.single) {
      return this.sliceIntoChunks(this.faqs, 4);
    }

    if (this.search !== "") {
      let cats: any = [];
      this.categories.forEach((c: any) => {
        let faqs = [];
        faqs = [
          ...this.faqs
            .filter((f: any) => {
              return f.faq_categories.includes(c.term_id);
            })
            .reduce((a: any, c: any) => {
              a.set(c.id, c);
              return a;
            }, new Map())
            .values()
        ];

        if (faqs.length === 0) {
          return;
        }

        cats.push({
          id: c.term_id,
          slug: c.slug,
          name: c.name,
          faqs: faqs
        });
      });

      return cats;
    }

    return this.categories
      .filter((c: any) => {
        if (this.categoryIds && this.categoryIds.includes(c.term_id)) {
          return c;
        }
      })
      .map((c: any) => {
        let faqs = [];
        faqs = [
          ...this.faqs
            .filter((f: any) => {
              return f.faq_categories.includes(c.term_id);
            })
            .reduce((a: any, c: any) => {
              a.set(c.id, c);
              return a;
            }, new Map())
            .values()
        ];

        return {
          id: c.term_id,
          slug: c.slug,
          name: c.name,
          faqs: faqs
        };
      });
  }
}
